import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AzureMapsService } from '../../services/azure-maps.service';
import { CityService } from '../../services/city.service';
import { CRMService } from '../../services/crm.service';
import { EmployeeService } from '../../services/employees.service';
import { NotificationService } from '../../services/notification.service';
import { RecordLockService } from '../../services/recordlock.service';
import { UtilService } from '../../services/util.service';
import {
    Customer
    , Employee
    , GeoCoordinate
    , RecordLock
    , RecordLockType
    , RecordType
    , SearchCityState
    , SearchRecordLock
} from '../../models/models';

@Component({
    selector: 'customer-quick-edit',
    templateUrl: './customer-quick-edit.component.html',
    standalone: false
})
export class CustomerQuickEdit implements OnChanges, OnInit {
    @Input() customerID: number = 0;
    @Input() pageType: string = "";
    @Output() onRefreshCustomer = new EventEmitter<any>();

    public customer: Customer = {} as Customer;
    public salesReps: Employee[] = [];
    public opsReps: Employee[] = [];
    public accountReps: Employee[] = [];
    //public cityZipList: City[] = [];
    //public cityStateZipList: SearchCityState[] = [];
    private customerCity: SearchCityState = {} as SearchCityState;
    public timeZoneName: string = "";
    public countryCode: string = "US";
    private usPhoneMask: string = "(999) 000-0000";
    private mexicoPhoneMask: string = "99-999-999-9999";
    public phoneMask: string = "(999) 000-0000";
    public defaultCustomerCity: string = "";
    public isCRMAdmin: boolean = false;
    public isLoading: boolean = false;

    private isLockEnabled: boolean = false;
    public isLocked: boolean = false;
    private recordLock: RecordLock = {} as RecordLock;
    private recordTypes: RecordType[] = [];
    private recordLockTypes: RecordLockType[] = [];
    public searchRecordLock: SearchRecordLock = {} as SearchRecordLock;

    public customerForm: UntypedFormGroup = new UntypedFormGroup({
        cityStateZipCtrl: new UntypedFormControl(''),
        cityCtrl: new UntypedFormControl('')
    });

    constructor(private azureMapsService: AzureMapsService, private cityService: CityService,
        private crmService: CRMService, private employeeService: EmployeeService,
        private notificationService: NotificationService, private recordLockService: RecordLockService,
        private utilService: UtilService) {
    }

    ngOnInit() {
        this.isCRMAdmin = this.getIsCRMAdmin();
        this.getEmployees();
        this.getRecordLockTypes();
        this.getRecordTypes();
        this.crmService.getCustomerById(this.customerID).subscribe(result => {
            this.customer = result;
            this.getCity();
            this.setTimeZoneName();

            if (this.isLockEnabled) {
                this.handleRecordLock(this.customerID);
            }

        //    if (this.customer.phone.length > 10 || this.customer.cell.length > 10) {
        //        this.countryCode = "MX";
        //        this.initValues();
        //    }
            console.log("ngOnInit", this.customer);
        });
    }

    ngOnChanges() {
        console.log("ngOnChanges", this.customer);
    }

    private initValues() {
        if (this.countryCode == "MX") {
            this.phoneMask = this.mexicoPhoneMask;
        }
        else {
            this.phoneMask = this.usPhoneMask;
        }
    }

    private getIsCRMAdmin() {
        var employeeRoles = localStorage.getItem('EmployeeRoles');

        //console.log(employeeRoles);
        if (employeeRoles != null && employeeRoles.length > 0) {
            if (employeeRoles.indexOf('CRM Admin') > -1) return true;
        }

        return false;
    }

    private getEmployees() {
        this.employeeService.getEmployeesByGroupName('Sales').subscribe(result => {
            this.salesReps = result;
        });

        this.employeeService.getEmployeesByGroupName('Ops Rep').subscribe(result => {
            this.opsReps = result;
        });

        this.employeeService.getEmployeesByGroupName('Account Managers').subscribe(result => {
            this.accountReps = result;
        });
    }

    public getCoords() {
        //var city = this.customerForm.controls['cityCtrl'].value as City;
        var city = this.customerCity;
        //if (city.cityId == undefined) {
        //    city = this.customer.city;
        //}
        this.azureMapsService.getGeoCoordinateByAddress(city.countryAbbr.trim(), city.stAbbr.trim(), city.zip, city.name, this.customer.address1).subscribe(result => {
            var coords: GeoCoordinate[] = result.resultCollection;
            if (coords.length > 0) {
                this.customer.latitude = coords[0].latitude;
                this.customer.longitude = coords[0].longitude;
            }
        });
    }

    private getCity() {
        this.cityService.getSearchCityStateByCityID(this.customer.cityId).subscribe(result => {
            if (result.resultCollection.length > 0) {
                var city: SearchCityState = result.resultCollection[0];
                this.customerCity = city;
                this.defaultCustomerCity = city.cityST;
            }
            else {
                this.notificationService.showWarning("Invalid or missing city.", "WARNING: Invalid City");
            }
        });
    }

    public citySTChanged(evt: any) {
        var cityID = evt;
        this.cityService.getSearchCityStateByCityID(cityID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.customerCity = result.resultCollection[0];
                this.customer.cityId = cityID;
                this.customer.apiZip = this.customerCity.zip;
                this.setTimeZoneName();
                this.getCoords();
                console.log("cityZipChanged:customerCity", cityID, this.customerCity, result);
            }
            else {
                this.notificationService.showWarning("Invalid or missing city.", "WARNING: Invalid City");
            }
        });
    }

    private setTimeZoneName() {
        if (this.customerCity.windowsRegistryTimeZoneName != null) {
            this.timeZoneName = this.customerCity.windowsRegistryTimeZoneName;
        }
        //else if (this.customer.city.epiTimeZone) {
        //    this.timeZoneName = this.customer.city.epiTimeZone.windowsRegistryTimeZoneName;
        //}
        //else if (this.customer.epiTimeZone) {
        //    this.timeZoneName = this.customer.epiTimeZone.windowsRegistryTimeZoneName;
        //}
    }

    public saveCustomer() {
        this.isLoading = true;
        //var city = this.customerForm.controls['cityCtrl'].value as City;
        var city = this.customerCity;
        if (city != null) {
            //this.customer.city = city;
            this.customer.cityId = city.cityID;
            console.log("saveCustomer", this.customer);
            this.crmService.saveCustomer(this.customer).subscribe(result => {
                this.isLoading = false;
                if (result.customerID > 0) {
                    //this.getCustomers();
                    if (this.isLockEnabled) {
                        this.clearRecordLock();
                    }
                    this.onRefreshCustomer.emit(result.customerID);
                } else {
                    this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
                }
            });
        }
        else {
            this.notificationService.showWarning("Invalid or missing city.", "WARNING: Invalid City");
        }

        this.customer = {} as Customer;
    }

    public cancelCustomer() {
        if (this.isLockEnabled) {
            this.clearRecordLock();
        }
        this.onRefreshCustomer.emit();
    }

    private getRecordLockTypes() {
        this.recordLockService.getRecordLockTypes().subscribe(result => {
            this.recordLockTypes = result.resultCollection;
        })
    }

    private getRecordTypes() {
        this.recordLockService.getRecordTypes().subscribe(result => {
            this.recordTypes = result.resultCollection;
        });
    }

    private clearRecordLock() {
        var recordTypeID = this.recordTypes.find(r => r.recordTypeName == "Customer")!.recordTypeID;
        var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
        var recordID = this.customerID;

        if (this.searchRecordLock.lockSource && this.searchRecordLock.lockSource == this.pageType + ": Quick Edit Customer") {
            // Clear all locks for this employee before handling the current record
            this.recordLockService.clearRecordLockByRecordTypeEmployeeRecord(recordTypeID, employeeID, recordID).subscribe(result => {
                var col = result.resultCollection;
                this.isLocked = false;
            });
            //this.recordLockService.clearRecordLock("QuoteOrder", recordID, this.recordLockSource);
        }
    }

    private handleRecordLock(id: number) {
        //var recordTypeID = this.recordTypes.find(r => r.recordTypeName == "Customer")!.recordTypeID;
        //var employeeID = parseInt(localStorage.getItem('EmployeeId')!);

        //console.log("handleRecordLock", id, actionType, recordTypeID, employeeID);

        // Clear all locks for this employee before handling the current record
        //    this.recordLockService.clearRecordLockByRecordTypeEmployee(recordTypeID, employeeID).subscribe(clearResult => {
        //        var col = clearResult.resultCollection;
        //    });
        // Handle the lock for this record
        this.recordLockService.getSearchRecordLockByRecordTypeNameRecordID("Customer", id).subscribe(result => {
            var canLock = false;
            if (result.resultCollection.length > 0) {
                //console.log("handleRecordLock:searchRecordLock", employeeID, id, result);
                var searchCol: SearchRecordLock[] = Object.assign([], result.resultCollection);
                searchCol = searchCol.filter(t => t.releasedByEmployeeID == null);
                this.searchRecordLock = searchCol[0];
                if (this.searchRecordLock != null) {
                    if (this.searchRecordLock.recordLockTypeName == "Unlocked") {
                        canLock = true;
                    }
                    this.recordLockService.getRecordLockByID(this.searchRecordLock.recordLockID).subscribe(resp => {
                        this.recordLock = resp.resultCollection[0];
                    });
                }
                else {
                    canLock = true;
                }
            }
            else {
                canLock = true;
            }
            if (canLock) {
                this.setRecordLock("Customer", id);
            }
            if (canLock || this.searchRecordLock == undefined) {
                this.isLocked = false;
            }
            else {
                this.isLocked = true;
            }
        });
    }

    private setRecordLock(type: string, id: number) {
        var lockSource: string = this.pageType + ": Quick Edit Customer";

        var recordLockType = this.recordLockTypes.find(r => r.recordLockTypeName == "Overridable");
        if (this.searchRecordLock != null && this.searchRecordLock.recordLockID) {
            // Update existing Unlocked record
            this.recordLock = {
                recordLockID: this.searchRecordLock.recordLockID,
                recordLockTypeID: recordLockType!.recordLockTypeID,
                recordTypeID: this.searchRecordLock.recordTypeID,
                recordID: id,
                checkedOutByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
                dateCheckedOut: this.utilService.getDateAsUTC(new Date()),
                lockSource: lockSource
                //releasedByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
                //dateReleased: new Date()
            }
        }
        else {
            // Create new lock if not found
            var recordType = this.recordTypes.find(r => r.recordTypeName == type);
            if (recordLockType != null && recordType != null) {
                this.recordLock = {
                    recordLockID: 0,
                    recordLockTypeID: recordLockType.recordLockTypeID,
                    recordTypeID: recordType.recordTypeID,
                    recordID: id,
                    checkedOutByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
                    dateCheckedOut: this.utilService.getDateAsUTC(new Date()),
                    lockSource: lockSource
                    //releasedByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
                    //dateReleased: new Date()
                }
            }
            //console.log("setRecordLock:null", id, type, recordLockType, recordType);
        }

        //console.log("setRecordLock", id, type, this.recordTypes, this.recordLock, this.searchRecordLock);

        this.recordLockService.saveRecordLock(this.recordLock).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.recordLock = result.resultCollection[0];
                //this.handleRecordLock(id);
            }
            else {
                // Failed to acquire lock (eg. two people clicked at same time)
                //this.handleRecordLock(id);
            }
        });
    }

    public overrideRecordLock(id: number) {
        //console.log("overrideRecordLock", id, this.recordLockAction, this.recordLock);
        if (this.recordLock && this.recordLock.recordID == id) {
            this.recordLock.recordLockTypeID = this.recordLockTypes.find(r => r.recordLockTypeName == "Overridable")!.recordLockTypeID;
            this.recordLock.checkedOutByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.recordLock.dateCheckedOut = this.utilService.getDateAsUTC(new Date());
            this.recordLock.releasedByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.recordLock.dateReleased = this.utilService.getDateAsUTC(new Date());

            this.recordLockService.saveRecordLock(this.recordLock).subscribe(result => {
                console.log("overrideRecordLock", id, result, this.recordLock);
                if (result.resultCollection.length > 0) {
                    this.recordLock = result.resultCollection[0];
                    //this.handleRecordLock(id);
                    this.isLocked = false;
                    //this.continueRecordLockAction();
                }
            });
        }
    }
}
